/**
 * @desc 提交问卷
 * @author Kody
 * @see http://api.umucdn.cn/project/51/interface/api/2567
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

import { ESurveySectionType } from '@umu/umu-types';

export interface IAnswer {
    question_id: number;
    type: ESurveySectionType;
    value: string;
    other_content?: string;
}

export interface ISubmitPollInput {
    element_id: number;
    is_anonymous: '1' | '0'; // 是否匿名
    answer: string; // IAnswer[]
    submit_type?: '1' | '0'; // 0-正题作答，1-主题互动
}

export interface ISubmitPollOutput {
    status: number;
    redirect_url: string;
    submit_code?: 40001 | 40002; // 40002 小节提交已结束 40001 小节提交未开始
}

export interface ISaveSurveyDraftInput {
    submit_id: number;
    session_id: number;
    answers: string; // IAnswer[]
}
export interface ISubmitSurveyInput {
    submit_id: number;
    session_id: number;
    is_anonymous: '1' | '0'; // 是否匿名
}

export const saveSurvey = (data: ISubmitPollInput): Promise<IResponse<ISubmitPollOutput>> => {
    return fetchData(Api.SAVE_SURVEY, data, { silent: true })
        .then((res: IResponse<ISubmitPollOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'saveSurvey',
                props: data,
                additionalInfo: {
                    description: 'saveSurvey fetchData error',
                },
            });
            throw err;
        });
};

export const saveSurveyDraft = (data: ISaveSurveyDraftInput): Promise<IResponse<ISubmitPollOutput>> => {
    return fetchData(Api.SAVE_SURVEY_DRAFT, data, { silent: true })
        .then((res: IResponse<ISubmitPollOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'saveSurveyDraft',
                props: data,
                additionalInfo: {
                    description: 'saveSurveyDraft fetchData error',
                },
            });
            throw err;
        });
};
export const submitSurvey = (data: ISubmitSurveyInput): Promise<IResponse<ISubmitPollOutput>> => {
    return fetchData(Api.SUBMIT_SURVEY, data, { silent: true })
        .then((res: IResponse<ISubmitPollOutput>) => {
            return res;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'submitSurvey',
                props: data,
                additionalInfo: {
                    description: 'submitSurvey fetchData error',
                },
            });
            throw err;
        });
};